export default __webpack_public_path__ + "static/media/DrugRegistry.071eccc2.svg";